module.exports = __webpack_public_path__ + "media/images/flags/1x1/pyf-97ab71a51203b1d4feae3eaa2b618dc7.svg";